import { Drawer, FormControlLabel, Grid, Icon, ListSubheader, MenuItem, Switch, Tab, Tabs, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { FormFieldKeyConditionEnum } from "../../../_common/enum/forms/fomFieldKeyCondition.enum";
import { FormFieldKeyActionEnum } from "../../../_common/enum/forms/formFieldKeyAction.enum";
import { FormFieldValueTypeEnum, isFormFieldValueTypeEnumOptions } from "../../../_common/enum/forms/formFieldValueType.enum";
import { IFormFieldKeyManage } from "../../../_common/models/formFieldKey";
import { FileUploadTypeAutoComplete } from "../../../_components/autocomplete/fileUploadType.autoComplete";
import { FormFieldKeyAutoComplete } from "../../../_components/autocomplete/formFieldKey.autoComplete";
import { FormFieldKeyLookupMultipleAutoComplete } from "../../../_components/autocomplete/formFieldKeyLookup.multipleComplete";
import { FormFieldKeySectionAutoComplete } from "../../../_components/autocomplete/formFieldKeySection.autoComplete";
import { PrimaryButton } from "../../../_components/button/primary.button";
import { DrawerHeader } from "../../../_components/drawer/header.drawer";
import { toastr } from "../../../_components/toastr/toastr";
import { getEnumDropdown } from "../../../_helpers/form.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { formFieldKeyService } from "../../../_services/formFieldKey.service";
import { formFieldKeyLookupService } from "../../../_services/formFieldKeyLookup.service";
import { FormFieldKeyConditionTypeEnum } from "../../../_common/enum/forms/fomFieldKeyConditionType.enum";
import { FormFieldKeySpecialTypeEnum } from "../../../_common/enum/forms/formFieldKeySpecialType.enum";

export function FormFieldKeyManageDrawer(params: {
    emitOnSave: () => void,
    emitOnClose: () => void
}) {
    let navigate = useNavigate();

    const { formTemplateSectionId, formFieldKeyId } = useParams<{ formTemplateSectionId: string, formFieldKeyId: string }>();
    const _formTemplateSectionId = +(formTemplateSectionId || 0);
    const _formFieldKeyId = +(formFieldKeyId || 0);

    const [data, setData] = useState<IFormFieldKeyManage>(getResetData);
    const [isLoading, setLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [tabValue, setTabValue] = React.useState(0);
    const [sectionFormFieldKeyLookups, setSectionFormFieldKeyLookups] = React.useState([]);
    const [sectionFormFieldKeys, setSectionFormFieldKeys] = React.useState([]);

    const formFieldValueTypeEnum = Object.keys(FormFieldValueTypeEnum);

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        navigate("");

        setTabValue(newValue);
    };

    useEffect(() => {
        if (_formFieldKeyId) fetchData();
        else setData(getResetData);
    }, []);


    useEffect(() => {
        if (data.hasFormFieldConditionDependency === true && (!data.formFieldKeyConditionDependencies || !data.formFieldKeyConditionDependencies.length)) {
            setData((_data) => ({ ..._data, formFieldKeyConditionDependencies: [{ formFieldKeyId: 0, conditionId: 0, value: "" }] }))
        }
    }, [data.hasFormFieldConditionDependency]);

    useEffect(() => {
        if (data.hasFormFieldKeyDependency === true && sectionFormFieldKeys.length < 1) {
            fetchFormFieldKeyData();
        }
        else if (data.hasFormFieldKeyDependency === false) {
            setData((_data) => { return { ..._data, formFieldKeyDependencyId: null } });
        }

    }, [data.hasFormFieldKeyDependency]);

    function getResetData(): IFormFieldKeyManage {
        return {
            id: 0 || +(_formFieldKeyId || 0),
            label: "",
            shortName: "",
            showLabel: false,
            formFieldValueTypeId: "",
            isRequired: false,
            formTemplateSectionId: _formTemplateSectionId,
            hasFormFieldKeyLookupDependency: false,
            hasFormFieldKeyDependency: false,
            hasSelectCondition: false,
            formFieldKeyLookupDependencyId: null,
            formFieldKeyDependencyId: null,
            hasFormFieldKeyDependency2: true,
            isGlobal: false,
            isAdminField: false,
            xsWidth: "",
            mdWidth: "",
            formFieldKeyFormFieldKeyLookups: [],
            formFieldKeyConditionDependencies: [],
            formFieldKeyActionId: 0,
            formFieldKeySpecialTypeId: "",
            description: "",
        };
    }

    function fetchData() {
        setLoading(true);
        return formFieldKeyService
            .get(+(_formFieldKeyId || 0))
            .then(
                (json) => {
                    if (json) {
                        json.formFieldValueTypeIdDb = json ? json.formFieldValueTypeId : null;

                        if (json.formFieldKeyFormFieldKeyLookups) {
                            json.formFieldKeyFormFieldKeyLookups = json.formFieldKeyFormFieldKeyLookups.map((m: any) => ({
                                id: m.formFieldKeyLookupId,
                            }))
                        }
                        setData(json);
                    }
                    else setData(getResetData);
                }, handleErrorResponse
            )
            .finally(() => setLoading(false));
    }

    function fetchFormFieldKeyLookupData() {

        return formFieldKeyLookupService
            .dropdown(_formTemplateSectionId)
            .then(
                (json) => {
                    setSectionFormFieldKeyLookups(json);
                }, handleErrorResponse
            );
    }

    function fetchFormFieldKeyData() {
        return formFieldKeyService
            .dropdown(_formTemplateSectionId)
            .then(
                (json) => {
                    setSectionFormFieldKeys(json);
                }, handleErrorResponse
            );
    }

    function closeModal() {
        params.emitOnClose();
    }

    function save(e: any) {
        e.preventDefault();
        setSaving(true);

        var fileInputField = document.getElementById("image")
        const formData = new FormData();
        formData.append("id", (data.id || 0).toString());
        formData.append("file", (fileInputField as any)?.files[0]);
        formData.append("formTemplateSectionId", (data.formTemplateSectionId || 0).toString());
        formData.append("formFieldValueTypeId", (data.formFieldValueTypeId || 0).toString());
        formData.append("shortName", (data.shortName || "").toString());


        formData.append("xsWidth", (data.xsWidth || "").toString());
        formData.append("mdWidth", (data.mdWidth || "").toString());

        formData.append("minValue", (data.minValue || "").toString());
        formData.append("maxValue", (data.maxValue || "").toString());

        formData.append("label", (data.label || "").toString());
        formData.append("isRequired", (data.isRequired || false).toString());
        formData.append("showLabel", (data.showLabel || false).toString());
        formData.append("hasSelectCondition", (data.hasSelectCondition || false).toString());
        formData.append("formFieldActionId", (data.formFieldActionId || "").toString());
        formData.append("fileUploadTypeId", (data.fileUploadTypeId || "").toString());

        formData.append("description", (data.description || "").toString());
        formData.append("sectionOrder", (data.sectionOrder || "").toString());
        formData.append("subSectionId", (data.subSectionId || "").toString());
        formData.append("formFieldKeySpecialTypeId", (data.formFieldKeySpecialTypeId || "").toString());

        formData.append("hasFormFieldConditionDependency", (data.hasFormFieldConditionDependency || false).toString());
        formData.append("isGlobal", (data.isGlobal || false).toString());
        formData.append("isAdminField", (data.isAdminField || false).toString());


        // formData.append("existingTableName", (data.sectionOrder || "").toString());
        // formData.append("condition", (data.sectionOrder || "").toString());

        formData.append("formFieldKeyActionId", (data.formFieldKeyActionId || "").toString());

        formData.append("hasFormFieldKeyLookupDependency", (data.hasFormFieldKeyLookupDependency || false).toString());
        formData.append("formFieldKeyLookupDependencyId", (data.formFieldKeyLookupDependencyId || "").toString());

        formData.append("hasFormFieldKeyDependency", (data.hasFormFieldKeyDependency || false).toString());
        formData.append("formFieldKeyDependencyId", (data.formFieldKeyDependencyId || "").toString());
        formData.append("formFieldKeyConditionTypeId", (data.formFieldKeyConditionTypeId || "").toString());
        formData.append("isQuestion", (data.isQuestion || false).toString());

        if (data.formFieldKeyFormFieldKeyLookups && data.formFieldKeyFormFieldKeyLookups.length) {
            data.formFieldKeyFormFieldKeyLookups.forEach((f: any, index: number) => {
                formData.append(`formFieldKeyFormFieldKeyLookups[${index}].formFieldKeyLookupId`, f.id);
            })
        }

        if (data.formFieldKeyConditionDependencies && data.formFieldKeyConditionDependencies.length && data.hasFormFieldConditionDependency) {
            data.formFieldKeyConditionDependencies.forEach((f: any, index: number) => {
                formData.append(`formFieldKeyConditionDependencies[${index}].Id`, f.id || 0);
                formData.append(`formFieldKeyConditionDependencies[${index}].FormFieldKeyId`, _formFieldKeyId.toString());
                formData.append(`formFieldKeyConditionDependencies[${index}].ConditionFormFieldKeyId`, f.conditionFormFieldKeyId || "");
                formData.append(`formFieldKeyConditionDependencies[${index}].Value`, f.value || "");
                formData.append(`formFieldKeyConditionDependencies[${index}].FormFieldKeyConditionId`, f.formFieldKeyConditionId || "");
            })
        }

        var fileInputField = document.getElementById("image")
        formData.append("file", (fileInputField as any)?.files[0]);

        return formFieldKeyService[(data.id || 0) > 0 ? "put" : "post"](formData)
            .then(
                (json) => {
                    toastr.success("Saved successfully");
                    params.emitOnSave();

                    if (+(_formFieldKeyId || 0) == 0) {
                        setData(getResetData);
                        navigate("../EditFormFieldKey/" + json.data)
                    }
                    else {
                        let _data = { ...data };
                        _data.formFieldValueTypeIdDb = _data.formFieldValueTypeId;
                        setData(_data);
                    }
                }, handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    function disable() {
        setSaving(true);
        return formFieldKeyService
            .disable(+(_formFieldKeyId || 0))
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    params.emitOnSave();
                    closeModal();
                }, handleErrorResponse
            )
            .finally(() => setSaving(false));
    }

    function handleChangeSwitch(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: !__data[event.target.name] } });
    };

    function handleChange(event: any) {
        setData((__data: any) => { return { ...__data, [event.target.name]: event.target.value } });
    };

    function onError(event: any) {
        toastr.error("Please verify that all fields have correct input");
    }

    function getLookupValues() {
        var _returnItems: any[] = [];

        if (sectionFormFieldKeyLookups && sectionFormFieldKeyLookups.length > 0) {
            sectionFormFieldKeyLookups.map((formFieldKeyLookups: any) => {
                _returnItems.push(<ListSubheader key={"lookup_header_key_" + formFieldKeyLookups[0].id}>{formFieldKeyLookups[0].formFieldKeyShortName}</ListSubheader>);

                if (formFieldKeyLookups && formFieldKeyLookups.length > 0) {
                    formFieldKeyLookups.map((formFieldKeyLookup: any) => {
                        _returnItems.push(<MenuItem key={"lookup_key_" + formFieldKeyLookup.id} value={formFieldKeyLookup.id.toString()}>{formFieldKeyLookup.name}</MenuItem>);
                    })
                }
            })
        }

        return _returnItems;
    }

    const shouldShowValues = data.formFieldValueTypeIdDb == FormFieldValueTypeEnum.Radio ||
        data.formFieldValueTypeIdDb == FormFieldValueTypeEnum.Checkbox ||
        data.formFieldValueTypeIdDb == FormFieldValueTypeEnum.Dropdown ||
        data.formFieldValueTypeIdDb == FormFieldValueTypeEnum.List ||
        data.formFieldValueTypeIdDb == FormFieldValueTypeEnum.RadioButton;


    return (
        <Drawer
            anchor={"right"}
            open={true}>

            <ValidatorForm onError={onError} onSubmit={save} noValidate>

                <DrawerHeader name={(!!_formFieldKeyId) ? "Update Form Field Key" : "Create Form Field Key"} onClose={closeModal} />


                {(+(_formFieldKeyId || 0) > 0) &&
                    <Tabs value={tabValue} onChange={handleTabChange} aria-label="simple tabs example">
                        <Tab label="Field" />
                        <Tab label="Values" disabled={!(shouldShowValues)} />
                    </Tabs>
                }



                {(tabValue === 0) &&
                    <Grid container spacing={1} >

                        <Grid item xs={12}>
                            {getEnumDropdown("Select Field Type", "formFieldValueTypeId", FormFieldValueTypeEnum, data["formFieldValueTypeId"], handleChange, true)}
                        </Grid>

                        <Grid item xs={12}>
                            <TextValidator
                                label="Label"
                                value={data.label}
                                autoFocus
                                name="label"
                                required={data.formFieldValueTypeId != FormFieldValueTypeEnum.SubSection}
                                fullWidth
                                validators={data.formFieldValueTypeId != FormFieldValueTypeEnum.SubSection ? ['required'] : []}
                                errorMessages={data.formFieldValueTypeId != FormFieldValueTypeEnum.SubSection ? ['This field is required'] : []}
                                onChange={handleChange}
                                variant="filled"
                            />
                        </Grid>

                        {(data.formFieldValueTypeId == FormFieldValueTypeEnum.List || data.formFieldValueTypeId == FormFieldValueTypeEnum.RadioButton) &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch checked={data.showLabel} onChange={handleChangeSwitch} name="showLabel" />}
                                    label="Show Label"
                                />
                            </Grid>
                        }

                        {data.formFieldValueTypeId == FormFieldValueTypeEnum.Slider &&
                            <>
                                <Grid item xs={6}>
                                    <TextValidator
                                        label="Min Value"
                                        value={data.minValue}
                                        name="minValue"
                                        fullWidth
                                        required
                                        type="number"
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                        onChange={handleChange}
                                        variant="filled"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextValidator
                                        label="Max Value"
                                        value={data.maxValue}
                                        name="maxValue"
                                        fullWidth
                                        required
                                        type="number"
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                        onChange={handleChange}
                                        variant="filled"
                                    />
                                </Grid>
                            </>
                        }

                        {data.formFieldValueTypeId == FormFieldValueTypeEnum.FileUpload &&
                            <Grid item xs={12}>

                                <FileUploadTypeAutoComplete
                                    isRequired
                                    itemId={data.fileUploadTypeId}
                                    name={"fileUploadTypeId"}
                                    onItemChange={handleChange} />
                            </Grid>

                        }
                        {data.formFieldValueTypeId != FormFieldValueTypeEnum.SubSection &&
                            <Grid item xs={12}>
                                <FormFieldKeySectionAutoComplete
                                    itemId={data.subSectionId}
                                    name={"subSectionId"}
                                    parentId={_formTemplateSectionId}
                                    onItemChange={handleChange} />

                            </Grid>
                        }

                        <Grid item xs={12}>
                            {getEnumDropdown("Special Key", "formFieldKeySpecialTypeId", FormFieldKeySpecialTypeEnum, data["formFieldKeySpecialTypeId"], handleChange, false)}
                        </Grid>

                        {/* {data.formFieldValueTypeId === FormFieldValueTypeEnum.ExistingTable &&
                            <>
                                <Grid item xs={6}>
                                    <SelectValidator
                                        value={data.existingTableName}
                                        onChange={handleChange}
                                        required
                                        label="Select Dependant Table"
                                        name="existingTableName"
                                        fullWidth
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                        variant="filled"
                                        InputLabelProps={{
                                            shrink: !!data.existingTableName,
                                        }}>

                                        <MenuItem value={"RacingLicense"}>RacingLicense</MenuItem>
                                    </SelectValidator>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextValidator
                                        label="Condition"
                                        value={data.condition}
                                        name="condition"
                                        fullWidth
                                        validators={['required']}
                                        errorMessages={['This field is required']}
                                        onChange={handleChange}
                                        variant="filled"
                                    />
                                </Grid>
                            </>
                        } */}



                        <Grid item xs={12}>
                            <TextValidator
                                label="Short Name"
                                value={data.shortName}
                                name="shortName"
                                fullWidth
                                onChange={handleChange}
                                variant="filled"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextValidator
                                label="Description"
                                value={data.description}
                                name="description"
                                fullWidth
                                onChange={handleChange}
                                variant="filled"
                            />
                        </Grid>

                        {(data.formFieldValueTypeId == FormFieldValueTypeEnum.Image || data.formFieldValueTypeId == FormFieldValueTypeEnum.FileDownload) &&
                            <Grid item xs={12}>
                                <TextField
                                    label="File"
                                    type="file"
                                    id="image"
                                    fullWidth
                                    variant="filled"
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        }

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.isRequired} onChange={handleChangeSwitch} name="isRequired" />}
                                label="Is Field Required"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.isGlobal} onChange={handleChangeSwitch} name="isGlobal" />}
                                label="Is Global Field"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.isAdminField} onChange={handleChangeSwitch} name="isAdminField" />}
                                label="Is Admin Field"
                            />
                        </Grid>

                        {(isFormFieldValueTypeEnumOptions(data.formFieldValueTypeId)) &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch checked={data.isQuestion} onChange={handleChangeSwitch} name="isQuestion" />}
                                    label="Is a Questionnaire Field"
                                />
                            </Grid>
                        }
                        <Grid item xs={6}>
                            <TextValidator
                                label="Mobile Width"
                                value={data.xsWidth}
                                name="xsWidth"
                                fullWidth
                                type="number"
                                validators={['matchRegexp:^([0-9]|1[0-2])$']}
                                errorMessages={['TNumber must be between 0-12']}
                                onChange={handleChange}
                                variant="filled"
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <TextValidator
                                label="Normal Width"
                                value={data.mdWidth}
                                name="mdWidth"
                                type="number"
                                validators={['matchRegexp:^([0-9]|1[0-2])$']}
                                errorMessages={['Number must be between 0-12']}
                                fullWidth
                                onChange={handleChange}
                                variant="filled"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextValidator
                                label="Section Order"
                                value={data.sectionOrder}
                                name="sectionOrder"
                                type="number"
                                validators={['matchRegexp:^([0-9]|[1-9][0-9])$']}
                                errorMessages={['Number must be between 0-99']}
                                fullWidth
                                onChange={handleChange}
                                variant="filled"
                                InputLabelProps={{
                                    shrink: !!data.sectionOrder,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            {getEnumDropdown("Select Field Action", "formFieldKeyActionId", FormFieldKeyActionEnum, data["formFieldKeyActionId"], handleChange, false)}
                        </Grid>

                        {(data.formFieldValueTypeId == FormFieldValueTypeEnum.String || data.formFieldValueTypeId == FormFieldValueTypeEnum.Textarea) &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch checked={data.hasSelectCondition} onChange={handleChangeSwitch} name="hasSelectCondition" />}
                                    label="Has Select Condition"
                                />
                            </Grid>
                        }


                        {(data.formFieldValueTypeId != FormFieldValueTypeEnum.Image && data.formFieldValueTypeId != FormFieldValueTypeEnum.FileDownload) &&
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Switch checked={data.hasFormFieldKeyDependency} onChange={handleChangeSwitch} name="hasFormFieldKeyDependency" />}
                                    label="Has Form Field Dependency?"
                                />
                            </Grid>
                        }



                        {(data.hasFormFieldKeyDependency === true && (sectionFormFieldKeys && sectionFormFieldKeys.length > 0)) &&
                            <Grid item xs={12}>

                                <FormFieldKeyAutoComplete
                                    isRequired
                                    parentId={_formTemplateSectionId}
                                    name={"formFieldKeyDependencyId"}
                                    itemId={data.formFieldKeyDependencyId}
                                    onItemChange={handleChange} />
                            </Grid>
                        }

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.hasFormFieldKeyLookupDependency} onChange={handleChangeSwitch} name="hasFormFieldKeyLookupDependency" />}
                                label="Has Form Field Key Lookup Dependency?"
                            />
                        </Grid>

                        {(data.hasFormFieldKeyLookupDependency === true) &&
                            <Grid item xs={12}>
                                <FormFieldKeyLookupMultipleAutoComplete
                                    isRequired
                                    groupedBy={"formFieldKeyShortName"}
                                    parentId={_formTemplateSectionId}
                                    name={"formFieldKeyFormFieldKeyLookups"}
                                    items={data.formFieldKeyFormFieldKeyLookups}
                                    onItemChange={handleChange} />

                            </Grid>
                        }

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.hasFormFieldConditionDependency} onChange={handleChangeSwitch} name="hasFormFieldConditionDependency" />}
                                label="Has Form Field Condition Dependency?"
                            />
                        </Grid>

                        {(data.hasFormFieldConditionDependency === true) &&
                            <>
                                <Grid item xs={12}>
                                    {getEnumDropdown("Condition Type", "formFieldKeyConditionTypeId", FormFieldKeyConditionTypeEnum, data["formFieldKeyConditionTypeId"], handleChange, true)}
                                </Grid>

                                <Grid item xs={12}>
                                    <PrimaryButton
                                        type="button"
                                        variant="success"
                                        onClick={() => {
                                            setData((_data) => ({ ..._data, formFieldKeyConditionDependencies: [..._data.formFieldKeyConditionDependencies, { formFieldKeyId: 0, formFieldKeyConditionId: 0, value: "" }] }))
                                        }} >
                                        <Icon>add</Icon> Add Another Condition
                                    </PrimaryButton>
                                </Grid>

                                {(data.formFieldKeyConditionDependencies && data.formFieldKeyConditionDependencies.length > 0) && data.formFieldKeyConditionDependencies.map((d: any, index: number) =>
                                    <>
                                        <Grid item xs={4}>

                                            <FormFieldKeyAutoComplete
                                                itemId={data.formFieldKeyConditionDependencies[index].conditionFormFieldKeyId}
                                                name={"conditionFormFieldKeyId"}
                                                isRequired
                                                parentId={_formTemplateSectionId}
                                                onItemChange={(event) => { setData((_data: any) => { { var formFieldKeyConditionDependencies = [..._data.formFieldKeyConditionDependencies]; formFieldKeyConditionDependencies[index].conditionFormFieldKeyId = event.target.value; return { ..._data, formFieldKeyConditionDependencies: formFieldKeyConditionDependencies } } }) }} />
                                        </Grid>

                                        <Grid item xs={3}>

                                            <SelectValidator
                                                value={data.formFieldKeyConditionDependencies[index].formFieldKeyConditionId}
                                                onChange={(event) => { setData((_data: any) => { { var formFieldKeyConditionDependencies = [..._data.formFieldKeyConditionDependencies]; formFieldKeyConditionDependencies[index].formFieldKeyConditionId = (event.target as any).value; return { ..._data, formFieldKeyConditionDependencies: formFieldKeyConditionDependencies } } }) }}
                                                required
                                                label="Select Condition"
                                                name="formFieldKeyConditionId"
                                                fullWidth
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                variant="filled"
                                                InputLabelProps={{
                                                    shrink: !!data.formFieldKeyConditionDependencies[index].formFieldKeyConditionId,
                                                }}>

                                                <MenuItem value={FormFieldKeyConditionEnum.EqualsTo.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.EqualsTo]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.EqualsOrGreater.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.EqualsOrGreater]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.EqualsOrLess.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.EqualsOrLess]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.Greater.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.Greater]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.Less.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.Less]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.Contains.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.Contains]}</MenuItem>
                                                <MenuItem value={FormFieldKeyConditionEnum.ContainsNot.toString()}>{FormFieldKeyConditionEnum[FormFieldKeyConditionEnum.ContainsNot]}</MenuItem>

                                            </SelectValidator>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <TextValidator
                                                label="Value"
                                                value={data.formFieldKeyConditionDependencies[index].value}
                                                name="value"
                                                required
                                                fullWidth
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                onChange={(event) => { setData((_data: any) => { { var formFieldKeyConditionDependencies = [..._data.formFieldKeyConditionDependencies]; formFieldKeyConditionDependencies[index].value = (event.target as any).value; return { ..._data, formFieldKeyConditionDependencies: formFieldKeyConditionDependencies } } }) }}
                                                variant="filled"
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <PrimaryButton
                                                type="button"
                                                variant="remove"
                                                onClick={() => { setData((_data) => { _data.formFieldKeyConditionDependencies.splice(index, 1); return { ..._data, formFieldKeyConditionDependencies: _data.formFieldKeyConditionDependencies } }) }} />
                                        </Grid>
                                    </>
                                )}

                            </>
                        }

                        {/* <Grid item xs={12}>
                            <FormControlLabel
                                control={<Switch checked={data.isGlobal} onChange={handleChangeSwitch} name="isGlobal" />}
                                label="Is Global Property"
                            />
                        </Grid> */}


                        <Grid item xs={data.id == 0 ? 12 : 6}>
                            <PrimaryButton
                                type="submit"
                                variant="primary"
                                disabled={isLoading}>
                                <Icon>check</Icon> {<>Save</>}
                            </PrimaryButton>
                        </Grid>

                        {(data.id > 0) &&
                            <Grid item xs={6}>
                                <PrimaryButton
                                    type="button"
                                    variant="danger"
                                    disabled={isLoading}
                                    onClick={disable}>

                                    <Icon>remove</Icon> Disable
                                </PrimaryButton>
                            </Grid>
                        }
                    </Grid>
                }

            </ValidatorForm>
            {
                (tabValue === 1 && (shouldShowValues)) &&
                <>
                    <Outlet />
                    {/* <FormFieldKeyLookupList formFieldKeyId={data.id} /> */}
                </>
            }

        </Drawer >
    );
}